import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import * as React from "react";

function CustomTabPanel(props) {
  const { children, value, index, contentSx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, ...contentSx }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.defaultProps = {
  contentSx: {},
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  contentSx: PropTypes.object,
};

export default CustomTabPanel;
